import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import FormikControl from "../../../layouts/Input/FormikControl";
import storage from "../../../apis/Storage";
import { Link } from "react-router-dom";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_DELIVERYMAN_TILL_DDL,
} from "../../../Types";
import {
  formatDate,
  renderCell,
  renderHeader,
} from "../../../utilities/FUNCTIONS";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import {
  getDropdownList,
  getDropdownListByPost,
} from "../../Shared/dropdownListActions";
import { isPermittedPage } from "../../../apis/Utility";
import {
  getMonthWiseM2DDetailReport,
  exportReport,
} from "./monthWiseM2DDetailReportActions";
import { useLocation } from "react-router-dom";

const MonthWiseM2DDetailReport = (props) => {
  const location = useLocation();
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  // pagination states
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setDistCenterList] = useState([]);
  const [deliverymanNameList, setDeliverymanNameList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);

  const [filter, setfilter] = useState({
    distributor: null,
    distCenter: null,
    deliverymanName: null,
    vizId: "",
    shopCode: "",
    fromMonth: new Date(),
    toMonth: new Date(),
  });
  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  /* ---------------- INITIAL LOAD (FROM SUMMARY CLICK) ---------------- */
  useEffect(() => {
    if (location?.state?.request) {
      const request = location.state.request;
      fetchReportData({
        distCenter: request.distId,
        deliverymanName: request.distCenterId,
        fromDate: formatDate(request.fromDate),
        toDate: formatDate(request.toDate),
        pageNo: 0,
        pageSize: currentPageSize,
      });

      setfilter((prev) => ({
        fromMonth: request.fromDate ? new Date(request.fromDate) : new Date(),
        toMonth: request.toDate ? new Date(request.toDate) : new Date(),
      }));
    } else {
      fetchReportData();
    }
  }, []);

  /* ---------------- REQUEST BUILDER ---------------- */
  function formRequestObject(isExport = false, overrides = {}) {
    const requestFromSummary = location?.state?.request;

    const hasFilterData =
      filter.distributor ||
      filter.distCenter ||
      filter.deliverymanName ||
      filter.vizId ||
      filter.shopCode;

    let requestData = {
      distributor: hasFilterData
        ? filter.distributor?.value
        : (requestFromSummary?.distributor ?? null),

      distCenter: hasFilterData
        ? filter.distCenter?.value
        : (requestFromSummary?.distId ?? null),

      deliverymanName: hasFilterData
        ? filter.deliverymanName?.value
        : (requestFromSummary?.deliverymanName ?? null),

      vizId: filter.vizId,
      shopCode: filter.shopCode,

      fromDate: formatDate(filter.fromMonth),
      toDate: formatDate(filter.toMonth),

      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      isExport: isExport,

      ...overrides, // 🔥 THIS IS THE KEY
    };

    if (
      userRights?.userType === "DistributorUser" ||
      userRights?.userType === "CoreAppUser"
    ) {
      requestData.distributorId = userRights?.distributorId;
    }

    return requestData;
  }

  function fetchReportData(request) {
    props.getMonthWiseM2DDetailReport(request);
  }

  function commonReset(reset = true) {
    if (reset) {
      setSearchText("");

      setfilter({
        distributor:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor
            : null,
        distCenter: null,
        deliverymanName: null,
        fromMonth: new Date(),
        toMonth: new Date(),
        pageNo: 0,
        searchText: null,
        isExport: false,
      });
    }
  }

  /* ---------------- PAGINATION ---------------- */
  const getData = (page) => {
    setCurrentPageNo(page);
    fetchReportData(
      formRequestObject(false, { pageNo: page, pageSize: currentPageSize }),
    );
  };

  const pageSizeChanged = (size) => {
    setCurrentPageNo(0);
    setCurrentPageSize(size);

    fetchReportData(formRequestObject(false, { pageNo: 0, pageSize: size }));
  };

  const searchChanged = (text) => {
    setSearchText(text);
  };

  useEffect(() => {
    setTotalRecords(props.MonthWiseM2DDetailReport?.totalRecords ?? 0);
  }, [props.MonthWiseM2DDetailReport.totalRecords]);

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };
  /* ------------fatch filters data --------- */
  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId,
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
      let distributorList = props.allDistributorList.filter((x) =>
        userRights?.distributorId.includes(x.value),
      );
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (
      userRights != null &&
      (userRights?.userType == "DistributorUser" ||
        userRights?.userType == "CoreAppUser")
    ) {
      let distCenterList = props.selectedDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value),
      );
      setDistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    } else {
      setDistCenterList(
        props.selectedDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        }),
      );
    }
  }, [props.selectedDistCentersList]);

  useEffect(() => {
    if (props.deliverymanTills) {
      setDeliverymanNameList(
        props.deliverymanTills.map(function (item) {
          return {
            value: item.qrCode,
            label: item.fullname,
          };
        }),
      );
    }
  }, [props.deliverymanTills]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL,
    );
  }, []);

  useEffect(() => {
    if (filter.distributor) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        { distributorIds: filter.distributor.value },
        GET_DISTRIBUTIONCENTER_DDL,
      );
    }
    filter.distCenter = null;
    filter.deliverymanName = null;
  }, [filter.distributor]);

  useEffect(() => {
    if (filter.distCenter) {
      props.getDropdownList(
        `api/DistCenter/GetCenterDeliveryUserDDL/${filter.distCenter.value}`,
        GET_DELIVERYMAN_TILL_DDL,
      );
    }
    filter.deliverymanName = null;
  }, [filter.distCenter]);

  const LoadDataByfilter = () => {
    setCurrentPageNo(0);

    fetchReportData(
      formRequestObject(false, { pageNo: 0, pageSize: currentPageSize }),
    );

    setShow(false);
    setIsApplyFilter(true);
  };

  useEffect(() => {
    console.log("RAW PAYLOAD:", props.MonthWiseM2DDetailReport);
  }, [props.MonthWiseM2DDetailReport]);

  /* ---------------- EXPORT ---------------- */
  const Download = () => {
    DownloadReportData(formRequestObject(true, { isExport: true }));
  };

  function DownloadReportData(request) {
    props.exportReport(request);
  }

  /* ---------------- COLUMNS (DETAIL) ---------------- */
  const columns = [
    { Header: "Distributor", accessor: "distributor" },
    { Header: "Dist. Center", accessor: "distCenter" },
    { Header: "Deliveryman Name", accessor: "deliverymanName" },
    { Header: "VIZ ID", accessor: "vizId" },
    { Header: "Shop Code", accessor: "shopCode" },
    { Header: "Shop Name", accessor: "shopName" },
    {
      Header: renderHeader("No. of Invoices"),
      accessor: "noOfInvoices",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Transacted Invoices"),
      accessor: "transactedInvoices",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Invoices Amount"),
      accessor: "invoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Updated Invoice Amount"),
      accessor: "updatedInvoiceAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("M2D Amount"),
      accessor: "m2DAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Non-VizLink Total"),
      accessor: "nonVizLinkTotal",
      Cell: ({ value }) => renderCell(value, true),
    },
  ];

  /* ---------------- UI ---------------- */
  return (
    <div>
      <VzPageContainer title="Month-Wise M2D Detail Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Month-Wise M2D Detail Report</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "300px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            {(userRights == null ||
                              userRights?.userType == "CoreAppUser") && (
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Distributor Name"
                                  name="distributor"
                                  options={distributorList}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      setfilter({
                                        ...filter,
                                        distributor: null,
                                      });
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      distributor: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.distributor}
                                />
                              </Col>
                            )}

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenter"
                                options={
                                  filter.distributor != null
                                    ? distCenterList
                                    : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      distCenter: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    distCenter: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.distCenter}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Deliveryman Name"
                                name="deliverymanName"
                                options={
                                  filter.distCenter != null
                                    ? deliverymanNameList
                                    : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      deliverymanName: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    deliverymanName: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.deliverymanName}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                control="input"
                                label="Viz Id"
                                name="vizId"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, vizId: value });
                                }}
                                value={filter.vizId}
                              />
                            </Col>

                            <Col xs={12} md={12}>
                              <FormikControl
                                control="input"
                                label="Shop Code"
                                name="shopCode"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, shopCode: value });
                                }}
                                value={filter.shopCode}
                              />
                            </Col>

                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromMonth: value });
                                  }}
                                  value={filter.fromMonth}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  control="date"
                                  label="To Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toMonth: value });
                                  }}
                                  value={filter.toMonth}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                  setIsApplyFilter(false),
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                  commonReset(isApplyFilter);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={Download}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.MonthWiseM2DDetailReport.data ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  MonthWiseM2DDetailReport: state.MonthWiseM2DDetailReport,
  allDistributorList: state.ddlList.allDistributorList
    ? state.ddlList.allDistributorList
    : [],
  selectedDistCentersList: state.ddlList.selectedDistCentersList
    ? state.ddlList.selectedDistCentersList
    : [],
  deliverymanTills: state.ddlList.deliverymanTills
    ? state.ddlList.deliverymanTills
    : [],
});

export default connect(mapStateToProps, {
  getMonthWiseM2DDetailReport,
  getDropdownList,
  getDropdownListByPost,
  exportReport,
})(MonthWiseM2DDetailReport);
